/** Delivery notes and picking slips (docs/superpowers/specs/2026-10-22-delivery-notes-picking-design.md). */

export type NoteType = 'customer_stock' | 'sale';
export type NoteStatus = 'draft' | 'ready' | 'part_picked' | 'picked' | 'despatched' | 'cancelled';

export interface DeliveryNoteLine {
  id?: number;
  lineNo?: number;
  productId: number | null;
  productName?: string;
  sku?: string;
  description?: string | null;
  qty: number;
  qtyPicked?: number;
  outstanding?: number;
  unitPrice: number | null;
}

export interface DeliveryNotePick {
  id: number;
  deliveryNoteLineId: number;
  locationCode: string;
  warehouseName: string;
  batchNumber: string | null;
  qty: number;
  pickedAt: string;
}

export interface DeliveryNote {
  id?: number;
  noteNumber?: string;
  pickingNumber?: string;
  noteType: NoteType;
  accountId: number | null;
  accountName?: string;
  status?: NoteStatus;
  requiredDate: string | null;
  customerRef: string | null;
  deliveryName: string | null;
  deliveryAddress1: string | null;
  deliveryAddress2: string | null;
  deliveryCity: string | null;
  deliveryPostCode: string | null;
  deliveryCountry: string | null;
  notes: string | null;
  vatRate: number;
  shortClosed?: boolean;
  despatchedAt?: string | null;
  createdAt?: string;
  lines: DeliveryNoteLine[];
  picks?: DeliveryNotePick[];
  totals?: { net: number; vat: number; gross: number } | null;
}

export interface PickSuggestion {
  warehouseLocationId: number;
  code: string;
  qty: number;
  available: number;
  batch: string | null;
}

export interface LineSuggestions {
  lineId: number;
  productId: number;
  productName: string;
  sku: string;
  outstanding: number;
  suggestions: PickSuggestion[];
}

export const STATUS_LABELS: Record<NoteStatus, string> = {
  draft: 'Draft', ready: 'Ready to pick', part_picked: 'Part picked', picked: 'Picked', despatched: 'Despatched', cancelled: 'Cancelled',
};

export const STATUS_BADGES: Record<NoteStatus, string> = {
  draft: 'badge-secondary', ready: 'badge-info', part_picked: 'badge-warning', picked: 'badge-primary', despatched: 'badge-success', cancelled: 'badge-dark',
};

export const TYPE_LABELS: Record<NoteType, string> = { customer_stock: 'Customer stock', sale: 'Sale' };

export function statusBadge(status: NoteStatus): string {
  return `<span class="badge ${STATUS_BADGES[status] || 'badge-secondary'}">${STATUS_LABELS[status] || status}</span>`;
}

export function ukDate(iso: string | null | undefined): string {
  return iso ? String(iso).slice(0, 10).split('-').reverse().join('/') : '';
}

/** A fresh reference for one confirm, so a retry or double tap cannot book the pick twice. */
export function newClientRef(): string {
  return 'web-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
}
